import React, { FC } from 'react';
import { CDSFlex } from '@ciscodesignsystems/cds-react-flex';
import { CDSStatusIconProps } from '@ciscodesignsystems/cds-react-icons';
import { CDSTag } from '@ciscodesignsystems/cds-react-tag';

export enum MappingStatuses {
  Added = 'added',
  Changed = 'changed',
  LeftChanged = 'leftChanged',
  RightChanged = 'rightChanged',
  Deleted = 'deleted',
  Unchanged = 'unchanged',
}

export const statusIconConfig: Record<
  MappingStatuses,
  { iconStatus: CDSStatusIconProps['status']; text: string }
> = {
  [MappingStatuses.Added]: {
    iconStatus: 'positive',
    text: 'Added',
  },
  [MappingStatuses.Changed]: {
    iconStatus: 'warning',
    text: 'Changed',
  },
  [MappingStatuses.LeftChanged]: {
    iconStatus: 'warning',
    text: 'Changed',
  },
  [MappingStatuses.RightChanged]: {
    iconStatus: 'warning',
    text: 'Changed',
  },
  [MappingStatuses.Deleted]: {
    iconStatus: 'negative',
    text: 'Deleted',
  },
  [MappingStatuses.Unchanged]: {
    iconStatus: 'inactive',
    text: 'Unchanged',
  },
};

interface IProps {
  status: MappingStatuses;
}

const MappingStatus: FC<IProps> = ({ status }) => {
  const { iconStatus, text } = statusIconConfig[status];

  return (
    <CDSFlex className="mapping-status">
      <CDSTag.Status
        status={iconStatus}
        wrap={false}>
        {text}
      </CDSTag.Status>
    </CDSFlex>
  );
};

export default MappingStatus;
